type PhoneType = {
  fill: string
  width: string
  height: string
  title: string
}

function Phone(props: PhoneType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'phone'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15 23'
      fill='none'
    >
      <title>{title}</title>
      <path
        d='M11.8128 1.4375H3.18783C1.86465 1.4375 0.791992 2.51015 0.791992 3.83333V19.1667C0.791992 20.4898 1.86465 21.5625 3.18783 21.5625H11.8128C13.136 21.5625 14.2087 20.4898 14.2087 19.1667V3.83333C14.2087 2.51015 13.136 1.4375 11.8128 1.4375Z'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M5.10449 1.4375V2.15625C5.10449 2.68552 5.53354 3.11458 6.06283 3.11458H8.93783C9.46711 3.11458 9.89616 2.68552 9.89616 2.15625V1.4375'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M4.14648 19.166H10.8548'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default Phone
